import { useEffect, useState } from 'react';

import Editor from '@draft-js-plugins/editor';
import { Box } from '@mui/material';
import {
    ContentState,
    DraftEditorCommand,
    DraftHandleValue,
    EditorState,
    RichUtils,
    convertFromHTML,
    convertToRaw,
} from 'draft-js';
import createListPlugin from 'draft-js-list-plugin';

import 'draft-js/dist/Draft.css';

const listPlugin = createListPlugin();
const plugins = [listPlugin];

interface TextEditorProps {
    label: string;
    setTextValues: any;
    errorMessage?: string;
    initialValue?: any[];
    placeholder?: string;
}

const TextEditor = ({
    label,
    setTextValues,
    errorMessage = '',
    initialValue = [],
    placeholder = '',
}: TextEditorProps) => {
    const [editorState, setEditorState] = useState(EditorState.createEmpty());

    useEffect(() => {
        if (initialValue.length) {
            let element = '';
            initialValue.map(
                ({ text, type }) =>
                    (element +=
                        type == 'unordered-list-item'
                            ? '<li>' + text + '</li>'
                            : '<div>' + text + '</div>')
            );
            const blockFromHtml = convertFromHTML(element);
            const contentState = ContentState.createFromBlockArray(
                blockFromHtml.contentBlocks,
                blockFromHtml.entityMap
            );
            setEditorState(EditorState.createWithContent(contentState));
        }
    }, []);

    useEffect(() => {
        const blocks = convertToRaw(editorState.getCurrentContent()).blocks;
        const mapBlocks = blocks.map(({ text, type }) => ({ text, type }));
        setTextValues(mapBlocks);
    }, [editorState]);

    const handleKeyCommand = (
        command: DraftEditorCommand,
        oldState: EditorState
    ): DraftHandleValue => {
        const newState = RichUtils.handleKeyCommand(oldState, command);
        if (newState) {
            setEditorState(newState);
            return 'handled';
        }
        return 'not-handled';
    };

    // Determine whether placeholder should be displayed (to avoid overlap with lists)
    const blockType = RichUtils.getCurrentBlockType(editorState);
    const isOl = blockType === 'ordered-list-item';
    const isUl = blockType === 'unordered-list-item';
    const placeholderIsVisible = !isOl && !isUl;

    return (
        <>
            <Box className="mb-5 font-bold">{label}</Box>
            <Box
                className={`form-text-area ${errorMessage ? 'input-error' : ''}`}
                sx={{ overflowX: 'auto', padding: '20px 10 20px 10' }}
            >
                <Editor
                    editorState={editorState}
                    handleKeyCommand={handleKeyCommand}
                    onChange={setEditorState}
                    placeholder={
                        placeholderIsVisible
                            ? placeholder
                                ? `${placeholder}`
                                : `Enter ${label}`
                            : ''
                    }
                    plugins={plugins}
                />
            </Box>
            <label className="error">{errorMessage}</label>
        </>
    );
};

export default TextEditor;
